import { SPACING } from '@common/theme/spacing'
import { Theme } from '@mui/material/styles'

export function MenuOverrides(theme: Theme) {
  return {
    MuiMenu: {
      styleOverrides: {
        list: {
          padding: theme.spacing(SPACING.noSpacing),
        },
        paper: {
          boxShadow: theme.shadows[4],
          borderRadius: theme.spacing(SPACING.borderRadiusSm),
        },
      },
    },
  }
}
